import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getModalSectionStyles = props => {
  var enableFullView = props.enableFullView,
    disableContentPadding = props.disableContentPadding;
  return StyleSheet.create({
    scrollContainer: {
      flex: 1
    },
    buttonWidgetContainer: {
      paddingTop: tokens.spacing.SPACING_4,
      marginTop: tokens.spacing.SPACING_20
    },
    stickyButtonWidgetContainer: {
      flexShrink: 0,
      width: '100%'
    },
    buttonShowBorderTop: {
      paddingTop: tokens.spacing.SPACING_16,
      paddingHorizontal: tokens.spacing.SPACING_20
    },
    footerElement: enableFullView || disableContentPadding ? {} : {
      marginBottom: -tokens.spacing.SPACING_20,
      marginLeft: -tokens.spacing.SPACING_20,
      marginRight: -tokens.spacing.SPACING_20
    }
  });
};